import VuexPersist from 'vuex-persist'

export default ({ store }) => {
  new VuexPersist({
    modules: ['cart', 'address', 'voucher', 'orders']
  }).plugin(store)
}
